const feathers = require('feathers/client')
const socketio = require('feathers-socketio/client')
const hooks = require('feathers-hooks')
// const errors = require('feathers-errors')
const auth = require('feathers-authentication-client')
const io = require('socket.io-client/dist/socket.io')

// const socket = io('http://localhost:3031', {
const socket = io('https://buget.verdedata.ro', {
// const socket = io('https://alobunaziua2.verdedata.ro', {
// const socket = io('https://buget.dragos.club', {
  transports: ['websocket']
})

// socket.io.on('connect_error', function (err) {
  // console.log(err)
  // socket.disconnect()
// })

const feathersClient = feathers()
  .configure(socketio(socket, {
    timeout: 60000
  }))
  .configure(hooks())
  .configure(auth({ storage: localStorage }))

export default feathersClient



// WEBPACK FOOTER //
// ./src/feathers/index.js